import { useState } from "react";

const DataEntryForm = () => {
  const [formData, setFormData] = useState({ name: "", value: "" });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await fetch("/api/addData", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) throw new Error("Failed to submit");

      setMessage("Data added successfully!");
      setFormData({ name: "", value: "" }); // Reset form
    } catch (error) {
      setMessage("Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>This Goes To The Tables Page!</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter name"
          required
        />
        <input
          type="text"
          name="value"
          value={formData.value}
          onChange={handleChange}
          placeholder="Enter value"
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
      {loading && <div className="spinner">🔄</div>}
      {message && <p>{message}</p>}
    </div>
  );
};

export default DataEntryForm;
